import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

const JewelryRepairs = () => {
  return (
    <section className="custom-design">
      <Container fluid className="showcase-container">
        {/* <div className="khan_custome_design_section jewelryRepairs_section"> */}
        <Row className="khan_custome_design_section jewelryRepairs_section w-100 m-auto">

          <Col lg={6} md={6} xs={12} sm={12}>
            <Heading>
              <h2>Jewelry Repairs To Maintain The
              Shine Of Your Treasures </h2>
              <p>
              Giving new life to your valuable keepsakes
              while maintaining their original beauty.
              
              </p>
            </Heading>

            <div className="text-center">
              <Link to="#" className="btn outline-base-btn large ">
              Get Started
              </Link>
            </div>
          </Col>
        </Row>
        {/* </div> */}
     
      </Container>
    </section>
  );
};

export default JewelryRepairs;
